export const STANDARD_TOAST_POSITION_CLASS = '-translate-x-1/2 fixed top-[72px] left-1/2';

/** 直播配置限流提示在所有端都显示在屏幕正中。 */
export const STANDARD_TOAST_H5_CENTER_POSITION_CLASS = '-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2';

export const STANDARD_TOAST_CLASS =
  'w-fit rounded-[100px] border-none bg-[#2E2F33] px-6 py-4 font-semibold text-sm text-white shadow-none backdrop-blur-[20px]';

export const STANDARD_TOAST_TEXT_CLASS = 'font-semibold text-sm text-white leading-5 opacity-100';

export const LIVE_TOAST_CLASS =
  'w-fit rounded-16 border-none bg-[rgba(42,42,42,0.6)] px-4 py-3 font-medium text-xs text-white shadow-none backdrop-blur-none sm:w-[calc(100vw-32px)] sm:max-w-[calc(100vw-32px)]';
export const LIVE_TOAST_TEXT_CLASS = 'font-medium text-xs text-white leading-[18px] opacity-100';
